<template>
  <div>
    <div class="input-mobile">
      <vh-form ref="phoneForm" :rules="rules" :model="form">
        <vh-form-item prop="phone">
          <vh-input
            v-model="form.phone"
            :placeholder="$t('login.login_1044')"
            :disabled="isReplay"
            class="input"
          ></vh-input>
        </vh-form-item>
      </vh-form>
      <div class="ruleTip" v-if="value.ext.edit && !isReplay">
        <span>短信验证</span>
        <vh-switch
          v-model="phoneValide"
          class="switch"
          active-color="#FB3A32"
          inactive-color="#CECECE"
          size="mini"
          :width="32"
        ></vh-switch>
        <span
          >{{
            phoneValide ? "已开启" : "开启后"
          }}，将对手机号进行国内号段校验及验证码验证</span
        >
      </div>
      <div
        v-if="phoneValide && isPreview && !isReplay"
        :class="isH5 ? 'vertify_wap' : 'vertify'"
      >
        <div id="captcha"></div>
        <div class="vertify_code">
          <vh-input
            type="text"
            class="input"
            maxlength="6"
            :placeholder="$t('login.login_1045')"
            v-model="phoneCode"
          ></vh-input>
          <vh-button
            class="code-btn"
            size="small"
            type="info"
            :disabled="!vertify_pass || !phoneKey"
            :class="{ red: vertify_pass && phoneKey }"
            @click="getCaptha"
            >{{ butText }}</vh-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v1 as uuidV1 } from "uuid";
export default {
  name: "phone",
  /* prettier-ignore */
  inject: ["sdk", "isPreview", "isH5", "id", "i18nLocal", "webinarId",'businessUid'],
  props: {
    value: {
      type: Object,
      default: "",
      cap: null,
    },
    isReplay: Boolean,
  },
  data() {
    return {
      phoneKey: "",
      phoneValide: true,
      form: {
        phone: "",
      },
      vertify_pass: false,
      rules: {
        phone: [{ validator: this.rexPhone(), trigger: "blur" }],
      },
      phoneCode: "",
      capInstance: null,
      timer: null,
      countTime: 60,
      butText: this.$t("form.form_1021"),
      timerTip: null,
    };
  },
  watch: {
    value: {
      handler(value) {
        // this.form = value;
      },
      immediate: true,
    },
    // 同步短信验证开关状态
    phoneValide: {
      handler(val) {
        this.value.verification = val ? "Y" : "N";
        if (val && this.isPreview) {
          this.initNECaptcha();
          this.rules.phone = [{ validator: this.rexPhone(), trigger: "blur" }];
        } else {
          let validatePass = (rule, value, callback) => {
            if (value === "" || !value) {
              callback(new Error(this.$t("login.login_1044")));
            } else {
              if (value !== "" && !/^\d{0,15}$/.test(value)) {
                callback(new Error(this.$t("login.login_1056")));
              } else {
                callback();
              }
            }
          };
          this.rules.phone = [{ validator: validatePass, trigger: "blur" }];
        }
      },
      // immediate: true,
    },
  },
  computed: {},
  mounted() {
    //回显数据
    if (this.value.replayData) {
      this.form.phone = this.value.replayData;
    }
    if (!this.isReplay) {
      this.phoneValide = this.value.verification == "Y" ? true : false;
      console.log(
        this.value.verification,
        this.isPreview,
        this.phoneValide,
        "this.phoneValide"
      );
      // 如果开启短信验证
      if (this.phoneValide && this.isPreview) {
        // this.$nextTick(() => {
        //   this.initNECaptcha();
        // });
        this.initNECaptcha();
      }
      this.refreshNECaptha();
    }

    // this.sdk.getById(this.id).then(res => {
    //   console.log('接口返回数据', res)
    //
    // })
  },
  methods: {
    getCaptha() {
      if (this.countTime > 0 && this.countTime < 60) return;
      this.sdk
        .sendPhoneCode({
          scene: 4,
          phone: this.form.phone,
          validate: this.phoneKey,
          uuid: uuidV1(),
          form_id: this.id, // 后端用来统一表单发送验证码相同
          webinar_id: this.webinarId,
          business_uid: this.businessUid,
        })
        .then((res) => {
          if (res && res.code === 200) {
            this.initInterval();
            if (this.isH5) {
              this.wapTip(this.$t("chat.chat_1010"));
            } else {
              this.$message.success(this.$t("chat.chat_1010"));
            }
            this.timer = setInterval(() => {
              this.countTime--;
              this.butText = `${this.countTime}s`;
              if (this.countTime === 0) {
                this.initInterval();
              }
            }, 1000);
          } else {
            if (this.isH5) {
              this.wapTip(
                this.$tec(res.code) || this.$t("account.account_1051")
              );
            } else {
              this.$message({
                message: this.$tec(res.code) || this.$t("account.account_1051"),
                showClose: true,
                type: "error",
                customClass: "zdy-info-box",
              });
            }
            this.refreshNECaptha(); // 重置易盾
          }
        })
        .catch((res) => {
          this.$message({
            message: this.$tec(res.code) || this.$t("account.account_1051"),
            showClose: true,
            type: "error",
            customClass: "zdy-info-box",
          });
          // 图片验证码重置
          this.refreshNECaptha(); // 重置易盾
        });
    },
    // 初始化定时器
    initInterval() {
      clearInterval(this.timer);
      this.timer = null;
      this.countTime = 60;
      this.butText = this.$t("form.form_1021");
    },
    // 初始化易盾
    initNECaptcha() {
      const _self = this;
      window.initNECaptcha(
        {
          captchaId: "b7982ef659d64141b7120a6af27e19a0",
          element: "#captcha",
          // width: 260,
          // height: 30,
          mode: "float",
          lang: this.i18nLocal === "en" ? "en" : "zh-CN",
          onReady: function (instance) {
            _self.capInstance = instance;
          },
          onVerify: function (err, data) {
            if (data) {
              _self.phoneKey = data.validate;
              console.log(_self.phoneKey, "_self.phoneKey");
            }
            if (err) {
              console.log(err);
            }
          },
          onError: function (e) {
            console.error(e);
          },
        },
        function onload(instance) {
          _self.cap = instance;
        }
      );
    },
    // 重置易盾
    refreshNECaptha() {
      this.phoneCode = null;
      this.capInstance && this.capInstance.refresh();
    },
    async check() {
      if (this.value.required === "Y" && !this.form.phone) {
        this.$refs["phoneForm"].validate();
        this.errorTip = "此项为必填项";
        return false;
      }
      let check = await this.checkPhoneCode();
      console.log(
        this.value.id,
        this.value,
        this.form.phone,
        this.form,
        check,
        "this.form.phone"
      );
      if (!check) return false;
      return { id: this.value.id, value: this.form.phone };
    },
    // 手机号正则
    rexPhone() {
      return (rule, value, callback) => {
        if (value === "" || !value) {
          callback(new Error(this.$t("login.login_1044")));
        } else {
          if (value !== "" && !/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(value)) {
            callback(new Error(this.$t("login.login_1056")));
          } else {
            this.vertify_pass = true;
            callback();
          }
        }
      };
    },
    // 验证码校验
    checkPhoneCode() {
      if (this.value.required == "Y" && this.value.verification == "Y") {
        return this.sdk
          .validatorPhoneCode({
            phone: this.form.phone,
            verify_code: this.phoneCode,
            scene: 4,
            form_id: this.id,
          })
          .then((res) => {
            if (res.code == 200 && res.data) {
              console.log(res.data, "checkPhoneCode");
              return res.data;
            } else {
              if (this.isH5) {
                this.wapTip(this.$t("cash.cash_1039"));
              } else {
                this.$message.warning(this.$t("cash.cash_1039"));
              }
              return false;
            }
          })
          .catch((err) => {
            console.log(err, "checkPhoneCode");
            return false;
          });
      } else {
        return true;
      }
    },
    // wap接口提示
    wapTip(val) {
      if (this.timerTip) {
        clearTimeout(this.timerTip);
        document.getElementById("vmp-wap-api-tip") &&
          document.body.removeChild(document.getElementById("vmp-wap-api-tip"));
      }
      let dom = document.createElement("div");
      dom.id = "vmp-wap-api-tip";
      dom.className = "vmp_wap_api_tip";
      dom.textContent = val;
      document.body.appendChild(dom);
      this.timerTip = setTimeout(() => {
        document.getElementById("vmp-wap-api-tip") &&
          document.body.removeChild(document.getElementById("vmp-wap-api-tip"));
      }, 3000);
    },
  },
};
</script>

<style lang="scss">
.input-mobile {
  #captcha {
    // margin-top: 14px;
    width: 50%;
    margin-right: 10px;
    ::v-deep .yidun.yidun--light {
      margin: 0;
    }
  }
  .ruleTip {
    margin-top: 10px;
    font-size: 14px;
  }

  .vertify {
    margin-top: 14px;
    display: flex;
    .vertify_code {
      width: 50%;
      position: relative;
      margin-left: 10px;
    }
    .code-btn {
      display: inline-block;
      position: absolute;
      right: 3px;
      top: 3px;
      height: 34px;
      width: 104px;
    }

    .red {
      color: #fff;
      border: 1px solid #fb3a32;
      background-color: #fb3a32;
    }
  }
  .vertify_wap {
    #captcha {
      width: 100%;
    }
    .vertify_code {
      margin-top: 24px;
      display: flex;
      .code-btn {
        margin-left: 8px;
        width: 130px;
      }
      .red {
        color: #fff;
        border: 1px solid #fb3a32;
        background-color: #fb3a32;
      }
    }
  }
}
.vmp_wap_api_tip {
  position: absolute;
  background: rgba($color: #666, $alpha: 0.5);
  padding: 8px;
  border-radius: 4px;
  left: 50%;
  bottom: 80px;
  transform: translate(-50%);
  z-index: 2000;
  font-size: 14px;
  line-height: 14px;
}
</style>
